module.exports = __webpack_public_path__ + "static/media/badge3.513a9da3.svg";